import { triggerHostMessagePreloadWidget } from '../triggerHostMessage/triggerHostMessagePreloadWidget';
export default function preloadWidgetHandler() {
  triggerHostMessagePreloadWidget(true);
}